import { QueryClient, useQuery } from '@tanstack/react-query';

import API from '@api/API';

export const useAppSettingsQuery = () => {
  const { isFetched, data, refetch } = useQuery({
    queryKey: useAppSettingsQuery.queryKey(),
    queryFn: useAppSettingsQuery.queryFn,
    enabled: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  return {
    appSettingsAreReady: isFetched,
    appSettings: data ?? {},
    refetchTokenIsValid: refetch,
  };
};
useAppSettingsQuery.queryKey = () => ['appSettings'];
useAppSettingsQuery.queryFn = () =>
  API.get<
    Partial<{
      smsDisclaimer?: string;
      featureFlags: {
        isEntertainerDashboardEnabled?: boolean;
        isPromoterEnabled?: boolean;
        isSuggestedEventsEnabled?: boolean;
        isSearchToAddEntertainerToEventEnabled?: boolean;
      };
      badgeReasons: string[];
      recommendationBadgeId?: string;
      primaryEntertainerMediaBadges: { _id: string; title: string; imageUrl: string }[];
      allEntertainerMediaBadges: { _id: string; title: string; imageUrl: string }[];
      supportActions: Record<
        string,
        {
          key: string;
          label: string;
          recommendationSlug: string;
          imgUrl: string;
        }
      >;
      dragShowCategories: string[];
    }>
  >(`/v1/settings`);

export const fetchAppSettings = async (queryClient: QueryClient) => {
  await queryClient.invalidateQueries({ queryKey: useAppSettingsQuery.queryKey() });

  return queryClient.fetchQuery({
    queryKey: useAppSettingsQuery.queryKey(),
    queryFn: useAppSettingsQuery.queryFn,
  });
};
